import { Action, createAction, handleActions } from "redux-actions";
import { calculateDate } from "~libs/dateCalculator";
import { FechaFiltro, FiltroValue, TakeValue } from "../../types";

/**
 * `estado` se guarda como lista porque el backend espera varios estados a la
 * vez; el selector manda uno solo, que puede ser la combinación "todos".
 */
interface FiltrosSolicitudesHistoricasState {
  take: TakeValue;
  page: number;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
  searchCriteria: string;
  estado: FiltroValue[];
}

const setInitialStateSolicitudesHistoricas = createAction(
  "SET_INITIAL_STATE_FILTRO_SOLICITUDES"
);

const setPage = createAction(
  "SET_LISTADO_SOLICITUDESEMISION_PAGE",
  (page: number) => ({
    page,
  })
);

const setTake = createAction(
  "SET_LISTADO_SOLICITUDESEMISION_ROWS_PER_PAGE",
  (take: TakeValue) => ({ take })
);

const selectFechaDesde = createAction(
  "SELECT_FECHA_DESDE_FILTRO",
  (fechaDesde: FechaFiltro) => ({ fechaDesde })
);

const selectFechaHasta = createAction(
  "SELECT_FECHA_HASTA_FILTRO",
  (fechaHasta: FechaFiltro) => ({ fechaHasta })
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_FILTRO",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const selectEstado = createAction(
  "SELECT_ESTADO_FILTRO",
  (estado: FiltroValue) => ({
    estado,
  })
);

const filtrosSolicitudesInitialState: FiltrosSolicitudesHistoricasState = {
  take: 10,
  page: 0,
  fechaDesde: calculateDate(new Date(), -30),
  fechaHasta: new Date(),
  searchCriteria: "",
  estado: ["PolizaEmitida", "Rechazada"],
};

const solicitudesHistoricasFiltrosReducer = handleActions<
  FiltrosSolicitudesHistoricasState,
  any
>(
  {
    [setInitialStateSolicitudesHistoricas.toString()]:
      (): FiltrosSolicitudesHistoricasState => {
        return {
          ...filtrosSolicitudesInitialState,
        };
      },
    [setPage.toString()]: (
      state: FiltrosSolicitudesHistoricasState,
      action: Action<{ page: number }>
    ): FiltrosSolicitudesHistoricasState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosSolicitudesHistoricasState,
      action: Action<{ take: TakeValue }>
    ): FiltrosSolicitudesHistoricasState => {
      return {
        ...state,
        take: action.payload.take,
      };
    },
    [selectFechaDesde.toString()]: (
      state: FiltrosSolicitudesHistoricasState,
      action: Action<{ fechaDesde: FechaFiltro }>
    ): FiltrosSolicitudesHistoricasState => {
      return {
        ...state,
        fechaDesde: action.payload.fechaDesde,
      };
    },
    [selectFechaHasta.toString()]: (
      state: FiltrosSolicitudesHistoricasState,
      action: Action<{ fechaHasta: FechaFiltro }>
    ): FiltrosSolicitudesHistoricasState => {
      return {
        ...state,
        fechaHasta: action.payload.fechaHasta,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosSolicitudesHistoricasState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosSolicitudesHistoricasState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectEstado.toString()]: (
      state: FiltrosSolicitudesHistoricasState,
      action: Action<{ estado: FiltroValue }>
    ): FiltrosSolicitudesHistoricasState => {
      let estado =
        action.payload.estado !== "PolizaEmitida" &&
        action.payload.estado !== "Rechazada" &&
        action.payload.estado !== "PolizaEmitida,Rechazada"
          ? "PolizaEmitida,Rechazada"
          : action.payload.estado;

      return {
        ...state,
        estado: [estado],
      };
    },
  },
  filtrosSolicitudesInitialState
);

export { solicitudesHistoricasFiltrosReducer };
export {
  setPage,
  setTake,
  selectFechaDesde,
  selectFechaHasta,
  selectSearchCriteria,
  setInitialStateSolicitudesHistoricas,
  selectEstado,
};
